import kids_01 from './JPEG/kids_01.jpg';
import kids_02 from './JPEG/kids_02.jpg';
import kids_03 from './JPEG/kids_03.jpg';
import kids_04 from './JPEG/kids_04.jpg';
import kids_05 from './JPEG/kids_05.jpg';
import kids_06 from './JPEG/kids_06.jpg';
import kids_07 from './JPEG/kids_07.jpg';
import kids_08 from './JPEG/kids_08.jpg';
import kids_09 from './JPEG/kids_09.jpg';
import kids_10 from './JPEG/kids_10.jpg';
import kids_11 from './JPEG/kids_11.jpg';
import kids_12 from './JPEG/kids_12.jpg';
import kids_13 from './JPEG/kids_13.jpg';
import kids_14 from './JPEG/kids_14.jpg';
import kids_15 from './JPEG/kids_15.jpg';
import kids_16 from './JPEG/kids_16.jpg';
import kids_17 from './JPEG/kids_17.jpg';
import kids_18 from './JPEG/kids_18.jpg';
import kids_19 from './JPEG/kids_19.jpg';
import kids_20 from './JPEG/kids_20.jpg';
import kids_21 from './JPEG/kids_21.jpg';
import kids_22 from './JPEG/kids_22.jpg';
import kids_23 from './JPEG/kids_23.jpg';
import kids_24 from './JPEG/kids_24.jpg';
import kids_25 from './JPEG/kids_25.jpg';
import kids_26 from './JPEG/kids_26.jpg';
import kids_27 from './JPEG/kids_27.jpg';
import kids_28 from './JPEG/kids_28.jpg';
import kids_29 from './JPEG/kids_29.jpg';
import kids_30 from './JPEG/kids_30.jpg';
import kids_31 from './JPEG/kids_31.jpg';
import kids_32 from './JPEG/kids_32.jpg';
import kids_33 from './JPEG/kids_33.jpg';
import kids_34 from './JPEG/kids_34.jpg';
import kids_35 from './JPEG/kids_35.jpg';
import kids_36 from './JPEG/kids_36.jpg';
import kids_37 from './JPEG/kids_37.jpg';
import kids_38 from './JPEG/kids_38.jpg';
import kids_39 from './JPEG/kids_39.jpg';
import kids_40 from './JPEG/kids_40.jpg';
import kids_41 from './JPEG/kids_41.jpg';
import kids_42 from './JPEG/kids_42.jpg';
import kids_43 from './JPEG/kids_43.jpg';
import kids_44 from './JPEG/kids_44.jpg';
import kids_45 from './JPEG/kids_45.jpg';
import kids_46 from './JPEG/kids_46.jpg';
import kids_47 from './JPEG/kids_47.jpg';
import kids_48 from './JPEG/kids_48.jpg';
import kids_49 from './JPEG/kids_49.jpg';
import kids_50 from './JPEG/kids_50.jpg';
import kids_51 from './JPEG/kids_51.jpg';
import kids_52 from './JPEG/kids_52.jpg';
import kids_53 from './JPEG/kids_53.jpg';
import kids_54 from './JPEG/kids_54.jpg';
import kids_55 from './JPEG/kids_55.jpg';
import kids_56 from './JPEG/kids_56.jpg';
import kids_57 from './JPEG/kids_57.jpg';
import kids_58 from './JPEG/kids_58.jpg';
import kids_59 from './JPEG/kids_59.jpg';
import kids_60 from './JPEG/kids_61.jpg';

const kids = [
  kids_01,
  kids_02,
  kids_03,
  kids_04,
  kids_05,
  kids_06,
  kids_07,
  kids_08,
  kids_09,
  kids_10,
  kids_11,
  kids_12,
  kids_13,
  kids_14,
  kids_15,
  kids_16,
  kids_17,
  kids_18,
  kids_19,
  kids_20,
  kids_21,
  kids_22,
  kids_23,
  kids_24,
  kids_25,
  kids_26,
  kids_27,
  kids_28,
  kids_29,
  kids_30,
  kids_31,
  kids_32,
  kids_33,
  kids_34,
  kids_35,
  kids_36,
  kids_37,
  kids_38,
  kids_39,
  kids_40,
  kids_41,
  kids_42,
  kids_43,
  kids_44,
  kids_45,
  kids_46,
  kids_47,
  kids_48,
  kids_49,
  kids_50,
  kids_51,
  kids_52,
  kids_53,
  kids_54,
  kids_55,
  kids_56,
  kids_57,
  kids_58,
  kids_59,
  kids_60,
];

export default kids;



// WEBPACK FOOTER //
// ./src/images/kids/index.js